import { useTheme as e } from "@lokalise/styled";
const r = () => e().mode;
export {
  r as useCurrentMode
};
//# sourceMappingURL=useCurrentMode.js.map
